export default "__VITE_ASSET__DsB815eL__"